import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addNewNotificationAction } from "./store/actions";
import { notificationSelector, onlineClientsSelector } from "./store/selector";
import {
  leaveFromChannelAction,
  sendMessageToChannelAction,
  subscribeToChannelAction,
} from "./store/socket-actions";

export function useSocketCore() {
  const dispatch = useDispatch();
  const onlineClients = useSelector(onlineClientsSelector);
  const notification = useSelector(notificationSelector);

  const subscribeToChannel = useCallback(
    async (
      userId: string,
      conversationId: string | null,
      channel: string,
      companyId: string
    ) => {
      try {
        dispatch(subscribeToChannelAction({ userId, conversationId, channel, companyId }));
      } catch (error: any) {
        console.error(error);
      }
    },
    [dispatch]
  );
  const leaveFromChannel = useCallback(
    async (channel: string) => {
      try {
        dispatch(leaveFromChannelAction({ channel }));
      } catch (error: any) {
        console.error(error);
      }
    },
    [dispatch]
  );
  const sendMessageToChannel = useCallback(
    async (channel: string, message: any) => {
      try {
        dispatch(sendMessageToChannelAction({ channel, message }));
      } catch (error: any) {
        console.error(error);
      }
    },
    [dispatch]
  );

  return {
    onlineClients,
    notification,
    subscribeToChannel,
    sendMessageToChannel,
    leaveFromChannel,
    addNewNotification: (id: string) =>
      dispatch(addNewNotificationAction({ id })),
  };
}
